import React, {useEffect, useState} from 'react';
import dayjs from "dayjs";
import {Month, Week} from "../data/CalendarTypes";
import CalenderWeek from "./CalenderWeek";
import Goal from "./Goal";
import dayOfYear from 'dayjs/plugin/dayOfYear'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library, IconProp} from '@fortawesome/fontawesome-svg-core'

/* import all the icons in Free Solid, Free Regular, and Brands styles */
import {fas} from '@fortawesome/free-solid-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'
import {fab} from '@fortawesome/free-brands-svg-icons'

// @ts-ignore
const leftArrow: IconProp = 'fa fa-arrow-left'
// @ts-ignore
const rightArrow: IconProp = 'fa fa-arrow-right'

library.add(fas, far, fab)

dayjs.extend(dayOfYear);
dayjs.extend(weekOfYear);


const GOAL_WORDS = 1_000_000;

function calendar(firstDay: dayjs.Dayjs, wordCounts: [{ day: dayjs.Dayjs, wordCount: number }]) {
    let month: Month = [[]];
    let dayIterator = firstDay.clone();
    for (let weekNumber = 1; weekNumber <= 5; weekNumber++) {
        const week: Week = [];

        for (let dayOfWeek = 1; dayOfWeek <= 7; dayOfWeek++) {

            const wordCount = wordCounts.find((e) =>
                e.day.date() === dayIterator.date() &&
                e.day.month() === dayIterator.month() &&
                e.day.year() === dayIterator.year()
            )?.wordCount || 0;

            week.push({
                date: dayIterator.clone(),
                dayOfWeek: dayOfWeek,
                dayOfMonth: dayIterator.date(),
                dayOfYear: dayIterator.dayOfYear(),
                wordCount: wordCount
            });

            dayIterator = dayIterator.add(1, "day");
        }

        month.push(week);
    }

    return month;
}


export default function Calender() {

    const [calendarWeeks, setCalendarWeeks] = useState<Month>([]);
    const [wordCount, setWordCount] = useState(0);
    const [remainingWordCount, setRemainingWordCount] = useState(0);
    const [monthWordCount, setMonthWordCount] = useState(0);
    const [currentMonth, setCurrentMonth] = useState(dayjs());

    const apiUrl = 'https://api.lavenderlongstories.com';

    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September",
        "October", "November", "December"
    ];

    const now = dayjs();
    const wordsPerDay = Math.floor(remainingWordCount / (now.endOf("year").dayOfYear() + 1 - now.dayOfYear()));

    async function getWordCounts(begin: any, end: any): Promise<[{ day: dayjs.Dayjs, wordCount: number }]> {
        const response = await fetch(apiUrl + "/wcs?" +
            new URLSearchParams({begin: begin.format('YYYY-MM-DD'), end: end.format('YYYY-MM-DD')}), {
            method: 'GET',
            headers: {
                "Content-Type": "application/json"
            }
        });

        return (await response.json()).map((e: any) => ({day: dayjs(e.day), wordCount: e.word_count}));
    }

    async function getWordCountTotal(begin: dayjs.Dayjs, end: dayjs.Dayjs): Promise<{ total: number }> {
        const response = await fetch(apiUrl + "/wcs-total?" +
            new URLSearchParams({begin: begin.format('YYYY-MM-DD'), end: end.format('YYYY-MM-DD')}), {
            method: 'GET',
            headers: {
                "Content-Type": "application/json"
            }
        });
        return await response.json();
    }

    function previousMonth() {
        setCurrentMonth(currentMonth.subtract(1, "month"));
    }

    function nextMonth() {
        setCurrentMonth(currentMonth.add(1, "month"));
    }


    useEffect(() => {
        async function load() {
            // This is the "top left" of the calendar,
            // the first displayed day
            //
            // ⌄⌄ Here
            // 29 30 31 01 02 03 04
            // 05 06 07 08 09 10 11
            // 12 13 14 15 16 17 18
            // 19 20 21 22 23 24 25
            // 26 27 28 29 30 01 02
            const firstDay = currentMonth.startOf("month").startOf("week");

            // This is the "bottom right" of the calendar,
            // the last displayed day
            //
            // 29 30 31 01 02 03 04
            // 05 06 07 08 09 10 11
            // 12 13 14 15 16 17 18
            // 19 20 21 22 23 24 25
            //                   ^^ Here
            const lastDay = firstDay.add(4, "weeks").endOf("week");

            const days = calendar(firstDay, (await getWordCounts(firstDay, lastDay)));
            setCalendarWeeks(days);

            const progress = (await getWordCountTotal(dayjs().startOf("year"), dayjs().endOf("year"))).total;
            setWordCount(progress);

            setRemainingWordCount(GOAL_WORDS - progress);

            const monthProgress = (await getWordCountTotal(currentMonth.startOf("month"), currentMonth.endOf("month"))).total
            setMonthWordCount(monthProgress);
        }

        load();
    }, [currentMonth]);

    return (
        <section id="goals" className='calender-section'>

            <Goal complete={wordCount} remaining={remainingWordCount}/>
            <div className="calendar-container">
                <div id="calendar" className="calendar">

                    <div className="inner-calender">
                        <div className="calendar-header">
                            <div className="calendar-header-day u-py-1">Sun</div>
                            <div className="calendar-header-day u-py-1">Mon</div>
                            <div className="calendar-header-day u-py-1">Tues</div>
                            <div className="calendar-header-day u-py-1">Wed</div>
                            <div className="calendar-header-day u-py-1">Thurs</div>
                            <div className="calendar-header-day u-py-1">Fri</div>
                            <div className="calendar-header-day u-py-1">Sat</div>
                        </div>
                        {calendarWeeks.map((week: Week) => {
                            return <CalenderWeek key={week[0]?.date?.week() || -1} week={week}
                                                 wordsPerDay={wordsPerDay}/>
                        })}

                    </div>
                    <div className="calendar-button-box">
                        <button id="calendar-left-arrow" onClick={previousMonth}>
                            <FontAwesomeIcon className={'icon'} icon={leftArrow}/>
                        </button>
                        <div className="calendar-month-label">
                            <span className="calendar-month">{months[currentMonth.month()]} {currentMonth.year()}</span>
                            <div className="total-month"> Total: {monthWordCount}</div>
                        </div>
                        <button id="calendar-right-arrow" onClick={nextMonth}>
                            <FontAwesomeIcon className={'icon'} icon={rightArrow}/>
                        </button>
                    </div>
                </div>

            </div>
        </section>
    )
}